import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AssignmentList from "./AssignmentList";
import { fetchAssignments } from "../pages/services/assignmentService";

const AllAssignments = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [assignments, setAssignments] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  // Pagination state
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10); // You can change this dynamically

  // Show success message if passed via location.state
  useEffect(() => {
    if (location.state?.successMessage) {
      setSuccessMessage(location.state.successMessage);
      setShowSuccessMessage(true);
      navigate(location.pathname, { replace: true });
    }
  }, [location.state, location.pathname, navigate]);

  // Auto-hide success message
  useEffect(() => {
    if (showSuccessMessage) {
      const timer = setTimeout(() => {
        setShowSuccessMessage(false);
        setSuccessMessage(null);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [showSuccessMessage]);

  // Fetch assignments based on current page and pageSize
  useEffect(() => {
    const getAssignments = async () => {
      try {
        setLoading(true);
        const fetchedData = await fetchAssignments(page, pageSize, "AssignmentTitle", "asc");
        setAssignments(fetchedData.data);
        setPagination(fetchedData.pagination);
      } catch (error) {
        setError("Error fetching assignments");
      } finally {
        setLoading(false);
      }
    };
    getAssignments();
  }, [page, pageSize]);

  if (loading) {
    return (
      <div className="overlay">
        <div className="custom-loader"></div>
        <p className="loading-text">Loading...</p>
      </div>
    );
  }

  if (error) {
    return <p className="error-text">{error}</p>;
  }

  return (
    <div>
      {showSuccessMessage && <div className="success-toast">{successMessage}</div>}
      <AssignmentList
        assignments={assignments}
        pagination={pagination}
        onPageChange={setPage}
        onPageSizeChange={setPageSize}
      />
    </div>
  );
};

export default AllAssignments;
